export default {
    cartItems(state) {
        if(state.sessionOrder === null) return [];
        const cartItems = [];
        state.sessionOrder.order_items.forEach(({product_id, combination_key, selected_wines, selected_add_ons, unit_price}) => {
            const index = cartItems.findIndex(cartItem => cartItem.combination_key === combination_key);
            if(index === -1) {
                cartItems.push({
                    product_id,
                    combination_key,
                    selected_wines,
                    selected_add_ons,
                    unit_price,
                    qty: 1
                })
            }else{
                cartItems[index].qty++;
            }
        });
        return cartItems;
    },
    products(state) {
        if(state.sessionOrder === null) return {};
        const _products = {};
        state.sessionOrder.products.forEach(product => {
            _products[product.id] = product;
        });
        return _products;
    },
    wines(state) {
        if(state.sessionOrder === null) return {};
        const _wines = {};
        state.sessionOrder.wines.forEach(wine => {
            if(_wines[wine.wine_group_id] === undefined) {
                _wines[wine.wine_group_id] = {};
            }
            _wines[wine.wine_group_id][wine.wine_id] = wine;
        });
        return _wines;
    },
    addOns(state) {
        if(state.sessionOrder === null || !Array.isArray(state.sessionOrder.add_ons)) return {};

        return state.sessionOrder.add_ons.reduce((addOns, addOn) => {
            addOns[addOn.id] = addOn;
            return addOns;
        }, {});

        // const _addOns = {};
        // state.sessionOrder.add_ons.forEach(addOn => {
        //     if(_addOns[addOn.add_on_category_id] === undefined) {
        //         _addOns[addOn.add_on_category_id] = {};
        //     }
        //     _addOns[addOn.add_on_category_id][addOn.add_on_id] = addOn;
        // });
        // return _addOns;
    },
    defaultDeliveryOption(state) {
        if(state.sessionOrder === null) return null;
        return state.sessionOrder.default_delivery_options;
    },
    deliveryOption(state) {
        if(state.sessionOrder === null) return {};
        const _deliveryOption = {};
        state.sessionOrder.delivery_options.forEach(item => {
            _deliveryOption[item.id] = item;
        })
        return _deliveryOption;
    },
    cartSettings(state) {
        if(state.sessionOrder === null) return {};
        return state.sessionOrder.cart_settings;
    }
}